<div class="stripe-payment-form-container">
  <form [formGroup]="paymentForm" (ngSubmit)="handleSubmit()" class="stripe-payment-form">
    <!-- Name Field -->
    <div class="form-field" *ngIf="config.showName">
      <label class="form-label"> Name on Card <span class="required">*</span> </label>
      <div class="input-wrapper stripe-wrapper">
        <div class="input-icon icon-user"></div>
        <input
          type="text"
          class="form-input form-input-name"
          formControlName="name"
          [class.error]="hasError('name')"
          placeholder="John Doe"
        />
      </div>
      <span class="card-form-error-message" *ngIf="hasError('name')"> Name is required </span>
    </div>
    <!-- Card Number -->
    <div class="form-field">
      <label class="form-label"> Card Number <span class="required">*</span> </label>
      <div class="input-wrapper stripe-wrapper">
        <div #cardNumber class="stripe-element"></div>
      </div>
      <span class="card-form-error-message" *ngIf="errors.cardNumber">
        {{ errors.cardNumber }}
      </span>
    </div>

    <!-- Expiry and CVC Row -->
    <div class="form-row">
      <!-- Expiry Date -->
      <div class="form-field">
        <label class="form-label"> Expiry Date <span class="required">*</span> </label>
        <div class="input-wrapper">
          <div class="input-icon icon-expiry"></div>
          <div #cardExpiry class="stripe-element"></div>
        </div>
        <span class="card-form-error-message" *ngIf="errors.cardExpiry">
          {{ errors.cardExpiry }}
        </span>
      </div>

      <!-- CVC -->
      <div class="form-field">
        <label class="form-label"> CVC <span class="required">*</span> </label>
        <div class="input-wrapper">
          <div class="input-icon icon-lock"></div>
          <div #cardCvc class="stripe-element"></div>
        </div>
        <span class="card-form-error-message" *ngIf="errors.cardCvc">
          {{ errors.cardCvc }}
        </span>
      </div>

      <!-- Zip Code -->
      <div class="form-field" *ngIf="config.showZipCode">
        <label class="form-label"> ZIP Code <span class="required">*</span> </label>
        <div class="input-wrapper">
          <div class="input-icon icon-location"></div>
          <div #postalCode class="stripe-element"></div>
        </div>
        <span class="card-form-error-message" *ngIf="errors.postalCode">
          {{ errors.postalCode }}
        </span>
      </div>
    </div>

    <!-- Save Card Checkbox -->
    <div class="form-field checkbox-field" *ngIf="config.showSaveCard">
      <label class="checkbox-label">
        <input type="checkbox" formControlName="saveCard" class="checkbox-input" />
        <span class="checkbox-text">Save this card for future payments</span>
      </label>
    </div>

    <!-- Payment Request Button (Apple Pay / Google Pay) -->
    <div class="payment-request-section" *ngIf="showApplePayButton">
      <div class="divider">
        <span>{{ "user.or" | translate }}</span>
      </div>

      <!-- Apple Pay Button Container -->
      <div style="position: relative;">
        <div id="apple-pay-button" class="apple-pay-container"></div>
        <!-- Overlay div when terms are not agreed -->
        <div *ngIf="!termsAccepted || !kioskChecked || !disclosureAgreementChecked"
        (click)="onApplePayButtonClick()"
        style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; cursor: pointer;"></div>
      </div>

      <mat-error *ngIf="checkboxError" class="apple-pay-mat-error">
        {{ checkboxError }}
      </mat-error>

      <div class="payment-method-benefits">
        <ul class="benefits-list">
          <li><i class="icon-check"></i><span>Fast and secure</span></li>
          <li><i class="icon-check"></i><span>No need to enter card details</span></li>
          <li><i class="icon-check"></i><span>Touch ID or Face ID authentication</span></li>
        </ul>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="customContent"></ng-container>
    <ng-content></ng-content>
    <!-- Action Buttons -->
    <div class="form-actions">
      <button
        data-testid="Purchase_button"
        type="submit"
        class="btn btn-primary"
        [disabled]="loading || !isFormValid"
        [class.loading]="loading"
      >
        <span *ngIf="!loading">{{ config.submitButtonText || "Submit" }}</span>
        <span *ngIf="loading" class="spinner"></span>
      </button>
      <button  data-testid="Go_back_button" type="button" class="btn btn-secondary" (click)="handleCancel()" [disabled]="loading">
        {{ config.cancelButtonText || "Cancel" }}
      </button>
    </div>

    <span  *ngIf="isAssurant"
           class="assurant-disclosure">
      In all states excluding Minnesota, Renters Insurance is underwritten by American Bankers Insurance Company of Florida, with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance Company. These companies operate under the trade name, Assurant®.
    </span>

    <!-- Validation Status -->
    <div class="validation-status" *ngIf="!isFormValid && !loading">
      <small class="text-muted">
        Please complete all required fields:
        <span *ngIf="!isCardNumberValid()" class="validation-item">• Card number</span>
        <span *ngIf="!isCardExpiryValid()" class="validation-item">• Expiry date</span>
        <span *ngIf="!isCardCvcValid()" class="validation-item">• CVC</span>
        <span *ngIf="config.showZipCode && !isPostalCodeValid()" class="validation-item">• ZIP code</span>
        <span *ngIf="!_termsAccepted" class="validation-item">• Accept terms</span>
        <span *ngIf="!kioskChecked || !disclosureAgreementChecked" class="validation-item">• Accept agreement</span>
      </small>
    </div>
  </form>
</div>
